const getCanvasHeight = (): number => {
  return window.innerHeight;
};

export default getCanvasHeight;
